import { render, staticRenderFns } from "./GameTap.vue?vue&type=template&id=6160acca&"
import script from "./GameTap.vue?vue&type=script&lang=js&"
export * from "./GameTap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports